import update from "immutability-helper";
import moment from "moment";
import _ from "underscore";
import Attrs from "assets/data/AttributeData";
import QuestionData from "assets/data/QuestionData";
import Keywords from "assets/data/Keywords";
import Customer from "models/Customer";
import Survey from "models/Survey";

export const SET_CREATE_SURVEY_CUSTOMER_ID =
  "createSurvey/SET_CREATE_SURVEY_CUSTOMER_ID";
export const SET_CREATE_SURVEY_DETAIL = "createSurvey/SET_CREATE_SURVEY_DETAIL";
export const APPLY_CREATE_SURVEY_DETAIL =
  "createSurvey/APPLY_CREATE_SURVEY_DETAIL";
export const SET_BASE_INFO_LOCALE = "createSurvey/SET_BASE_INFO_LOCALE";
export const CHANGE_BASE_INFO_USE_LOCALE =
  "createSurvey/CHANGE_BASE_INFO_USE_LOCALE";
export const CHANGE_BASE_INFO_ITEM = "createSurvey/CHANGE_BASE_INFO_ITEM";
export const CHANGE_BASE_INFO_TERM = "createSurvey/CHANGE_BASE_INFO_TERM";
export const UPDATE_BASE_INFO = "createSurvey/UPDATE_BASE_INFO";
export const SET_ALERT_CONFIG = "createSurvey/SET_ALERT_CONFIG";
export const SET_MAIL_SEND_TO_EMPLOYEE = "createSurvey/SET_MAIL_SEND_TO_EMPLOYEE";// 自由記入チェックボックスの変更
export const CHANGE_FREE_COMMENT_CHECKBOX_1 =
  "createSurvey/CHANGE_FREE_COMMENT_CHECKBOX_1";
export const CHANGE_FREE_COMMENT_CHECKBOX_2 =
  "createSurvey/CHANGE_FREE_COMMENT_CHECKBOX_2";

export const SET_SELECT_ATTR_LOCALE = "createSurvey/SET_SELECT_ATTR_LOCALE";
export const RELOAD_SELECT_ATTR = "createSurvey/RELOAD_SELECT_ATTR";
export const CHANGE_SELECT_ATTR_USE_ATTRS =
  "createSurvey/CHANGE_SELECT_ATTR_USE_ATTRS";
export const CHANGE_SELECT_ATTR_ITEM = "createSurvey/CHANGE_SELECT_ATTR_ITEM";
export const UPDATE_SELECT_ATTR_ORDER = "createSurvey/UPDATE_SELECT_ATTR_ORDER";
export const UPDATE_SELECT_ATTR = "createSurvey/UPDATE_SELECT_ATTR";

export const INIT_BASE_WORD = "createSurvey/INIT_BASE_WORD";
export const SET_BASE_WORD_INFO = "createSurvey/SET_BASE_WORD_INFO";
export const SET_BASE_WORD_LOCALE = "createSurvey/SET_BASE_WORD_LOCALE";
export const SET_BASE_WORD_EDIT = "createSurvey/SET_BASE_WORD_EDIT";
export const SET_BASE_WORD_SELECT_ID = "createSurvey/SET_BASE_WORD_SELECT_ID";
export const UPDATE_BASE_WORD_ITEMS = "createSurvey/UPDATE_BASE_WORD_ITEMS";
export const CHANGE_BASE_WORD_ITEM = "createSurvey/CHANGE_BASE_WORD_ITEM";
export const CHANGE_BASE_WORD_SELECTION =
  "createSurvey/CHANGE_BASE_WORD_SELECTION";
export const OPEN_BASE_WORD_REPLACE_MODAL =
  "createSurvey/OPEN_BASE_WORD_REPLACE_MODAL";
export const CLOSE_BASE_WORD_REPLACE_MODAL =
  "createSurvey/CLOSE_BASE_WORD_REPLACE_MODAL";
export const DISCARD_BASE_WORD = "createSurvey/DISCARD_BASE_WORD";
export const UPDATE_BASE_WORD = "createSurvey/UPDATE_BASE_WORD";
export const REPLACE_ALL_BASE_WORD = "createSurvey/REPLACE_ALL_BASE_WORD";

export const INIT_ADDITIONS = "createSurvey/INIT_ADDITIONS";
export const SET_ADDITIONS_INFO = "createSurvey/SET_ADDITIONS_INFO";
export const SET_ADDITIONS_LOCALE = "createSurvey/SET_ADDITIONS_LOCALE";
export const SET_ADDITIONS_EDIT = "createSurvey/SET_ADDITIONS_EDIT";
export const SET_ADDITIONS_SELECT_ID = "createSurvey/SET_ADDITIONS_SELECT_ID";
export const UPDATE_ADDITIONS_ITEMS = "createSurvey/UPDATE_ADDITIONS_ITEMS";
export const ADD_ADDITIONS_NEW_ITEM = "createSurvey/ADD_ADDITIONS_NEW_ITEM";
export const REMOVE_ADDITIONS_ITEM = "createSurvey/REMOVE_ADDITIONS_ITEM";
export const ADD_ADDITIONS_NEW_ANSWER = "createSurvey/ADD_ADDITIONS_NEW_ANSWER";
export const REMOVE_ADDITIONS_ANSWER = "createSurvey/REMOVE_ADDITIONS_ANSWER";
export const CHANGE_ADDITIONS_ANSWER = "createSurvey/CHANGE_ADDITIONS_ANSWER";
export const SET_ADDITIONS_PT_REVERSE = "createSurvey/SET_ADDITIONS_PT_REVERSE";
export const DISCARD_ADDITIONS = "createSurvey/DISCARD_ADDITIONS";
export const CHANGE_ADDITIONS_ITEM = "createSurvey/CHANGE_ADDITIONS_ITEM";
export const UPDATE_ADDITIONS = "createSurvey/UPDATE_ADDITIONS";

export const OPEN_PREVIEW_MODAL = "createSurvey/OPEN_PREVIEW_MODAL";
export const CLOSE_PREVIEW_MODAL = "createSurvey/CREATE_PREVIEW_MODAL";
export const SET_CREATE_SURVEY_ERRORS = "createSurvey/SET_CREATE_SURVEY_ERRORS";
export const SET_SELECT_SURVEY_ERRORS = "createSurvey/SET_SELECT_SURVEY_ERRORS";
export const SET_PREVIEW_LOCALE = "createSurvey/SET_PREVIEW_LOCALE";
export const CHANGE_PREVIEW_ITEM = "createSurvey/CHANGE_PREVIEW_ITEM";
export const OPEN_SELECT_SURVEY_MODAL = "createSurvey/OPEN_SELECT_SURVEY_MODAL";
export const CLOSE_SELECT_SURVEY_MODAL =
  "createSurvey/CLOSE_SELECT_SURVEY_MODAL";
export const SET_ATTR_UPDATE_AT = "createSurvey/SET_ATTR_UPDATE_AT";

// 日付形式の定数（保存値のセット、または変更時の値のセットのフォーマット）
const DATE_FORMAT = "YYYY-MM-DDTHH:mm";

// common
export const setCreateSurveyCustomerId = id => ({
  type: SET_CREATE_SURVEY_CUSTOMER_ID,
  id
});
export const setSurveyDetail = res => ({
  type: SET_CREATE_SURVEY_DETAIL,
  customer: new Customer(res.customer),
  survey: new Survey(res.survey),
  surveys: res.surveys,
  locales: res.locales,
  attrs: res.attrs,
  canUseLocales: res.canUseLocales,
  selectedAttrs: res.selectedAttrs,
  surveyLocales: res.surveyLocales,
  customerLocales: res.locales.map(locale => locale.locale.key),
  baseWordItems: res.baseWordItems,
  additionsItems: res.additionsItems,
  attrUpdatedAt: res.attrUpdatedAt,
  alertDays: res.alertDays,
  isChecked: res.isChecked,
  isMailSendToEmployee: res.survey ? res.survey.isMailSendToEmployee : null,
});
export const applySurveyDetail = res => ({
  type: APPLY_CREATE_SURVEY_DETAIL,
  survey: new Survey(res.survey),
  attrs: res.attrs,
  baseWordItems: res.baseWordItems,
  additionsItems: res.additionsItems,
  selectedAttrs: res.selectedAttrs,
  surveyLocales: res.surveyLocales
});
// BaseInfo Actions
export const setBaseInfoLocale = localeNo => ({
  type: SET_BASE_INFO_LOCALE,
  localeNo
});
export const changeBaseInfoUseLocales = (check, localeNo) => ({
  type: CHANGE_BASE_INFO_USE_LOCALE,
  check,
  localeNo
});
export const changeBaseInfoItem = (key, value, locale) => ({
  type: CHANGE_BASE_INFO_ITEM,
  key,
  value,
  locale
});
export const changeBaseInfoTerm = (key, value) => ({
  type: CHANGE_BASE_INFO_TERM,
  key,
  value
});
export const setAlertConfig = (alertDays, isChecked) => ({
  type: SET_ALERT_CONFIG,
  alertDays,
  isChecked
});

export const setMailSendToIndividual = (isMailSendToEmployee) => ({
  type: SET_MAIL_SEND_TO_EMPLOYEE,
  isMailSendToEmployee
});
export const updateBaseInfo = res => ({
  type: UPDATE_BASE_INFO,
  res
});
// 自由記入チェックボックスの変更
export const changeFreeCommentCheckbox1 = flg => ({
  type: CHANGE_FREE_COMMENT_CHECKBOX_1,
  flg
});
export const changeFreeCommentCheckbox2 = flg => ({
  type: CHANGE_FREE_COMMENT_CHECKBOX_2,
  flg
});

// SelectAttr Actions
export const setSelectAttrLocale = localeNo => ({
  type: SET_SELECT_ATTR_LOCALE,
  localeNo
});
export const reloadAttrs = res => ({
  type: RELOAD_SELECT_ATTR,
  res
});
export const changeSelectAttrUseAttrs = (check, index) => ({
  type: CHANGE_SELECT_ATTR_USE_ATTRS,
  check,
  index
});
export const changeSelectAttrItem = (key, value) => ({
  type: CHANGE_SELECT_ATTR_ITEM,
  key,
  value
});
export const updateSelectAttrOrder = (key, value) => ({
  type: UPDATE_SELECT_ATTR_ORDER,
  key,
  value
});
export const updateSelectAttr = res => ({
  type: UPDATE_SELECT_ATTR,
  res
});

// BaseWord Actions
export const initBaseWord = () => ({
  type: INIT_BASE_WORD
});
export const setBaseWordInfo = res => ({
  type: SET_BASE_WORD_INFO,
  res
});
export const setBaseWordLocale = localeNo => ({
  type: SET_BASE_WORD_LOCALE,
  localeNo
});
export const setBaseWordEdit = check => ({
  type: SET_BASE_WORD_EDIT,
  check
});
export const setBaseWordSelectedId = id => ({
  type: SET_BASE_WORD_SELECT_ID,
  id
});
export const updateBaseWordItems = (item, index) => ({
  type: UPDATE_BASE_WORD_ITEMS,
  item,
  index
});
export const changeBaseWordItem = (key, value) => ({
  type: CHANGE_BASE_WORD_ITEM,
  key,
  value
});
export const changeBaseWordSelection = moveNo => ({
  type: CHANGE_BASE_WORD_SELECTION,
  moveNo
});
export const openReplaceModal = () => ({
  type: OPEN_BASE_WORD_REPLACE_MODAL
});
export const closeReplaceModal = () => ({
  type: CLOSE_BASE_WORD_REPLACE_MODAL
});
export const discardBaseWord = res => ({
  type: DISCARD_BASE_WORD,
  res
});
export const updateBaseWord = res => ({
  type: UPDATE_BASE_WORD,
  res
});
export const replaceAllBaseWord = keywords => ({
  type: REPLACE_ALL_BASE_WORD,
  selectKeys: keywords
});

export const openPreviewModal = (
  localeNo,
  selectedItemId,
  items,
  additionMode,
  choices
) => ({
  type: OPEN_PREVIEW_MODAL,
  localeNo,
  selectedItemId,
  items,
  additionMode,
  choices
});
export const closePreviewModal = () => ({
  type: CLOSE_PREVIEW_MODAL
});

// Additions Actions
export const initAdditions = () => ({
  type: INIT_ADDITIONS
});
export const setAdditionsInfo = res => ({
  type: SET_ADDITIONS_INFO,
  res
});
export const setAdditionsLocale = localeNo => ({
  type: SET_ADDITIONS_LOCALE,
  localeNo
});
export const setAdditionsEdit = check => ({
  type: SET_ADDITIONS_EDIT,
  check
});
export const setAdditionsSelectedId = id => ({
  type: SET_ADDITIONS_SELECT_ID,
  id
});
export const updateAdditionsItems = (index, atIndex) => ({
  type: UPDATE_ADDITIONS_ITEMS,
  index,
  atIndex
});
export const changeAdditionsItem = (key, value) => ({
  type: CHANGE_ADDITIONS_ITEM,
  key,
  value
});
export const addAdditionsNewItem = () => ({
  type: ADD_ADDITIONS_NEW_ITEM
});
export const removeAdditionsItem = index => ({
  type: REMOVE_ADDITIONS_ITEM,
  index
});
export const addAdditionsNewAnswer = () => ({
  type: ADD_ADDITIONS_NEW_ANSWER
});
export const removeAdditionsAnswer = index => ({
  type: REMOVE_ADDITIONS_ANSWER,
  index
});
export const changeAdditionsAnswer = (index, name) => ({
  type: CHANGE_ADDITIONS_ANSWER,
  index,
  name
});
export const setAdditionsPtReverse = () => ({
  type: SET_ADDITIONS_PT_REVERSE
});
export const discardAdditions = res => ({
  type: DISCARD_ADDITIONS,
  res
});
export const updateAdditions = res => ({
  type: UPDATE_ADDITIONS,
  res
});

export const setErrors = errors => ({
  type: SET_CREATE_SURVEY_ERRORS,
  errors
});
export const setSelectSurveyErrors = errors => ({
  type: SET_SELECT_SURVEY_ERRORS,
  errors
});
// Preview Actions
export const setPreviewLocale = localeNo => ({
  type: SET_PREVIEW_LOCALE,
  localeNo
});
export const changePreviewItem = moveNo => ({
  type: CHANGE_PREVIEW_ITEM,
  moveNo
});
// SelectSurvey Actions
export const openSelectSurveyModal = () => ({
  type: OPEN_SELECT_SURVEY_MODAL
});
export const closeSelectSurveyModal = () => ({
  type: CLOSE_SELECT_SURVEY_MODAL
});
export const setAttrUpdateAt = attrUpdatedAt => ({
  type: SET_ATTR_UPDATE_AT,
  attrUpdatedAt
});

const initialState = {
  isChecked: false,
  alertDays: '',
  baseInfo: {
    init: false,
    canUseLocales: [],
    useLocales: [],
    localeNo: "",
    employees: 0,
    additionLimit: 0,
    items: {},
    originTermFrom: "",
    termFrom: "",
    termTo: "",
    baseSurveyId: "",
    lockVersion: ""
  },
  selectAttr: {
    init: false,
    selectedAttrs: [],
    localeNo: "",
    answerMethods: {},
    items: [],
    lockVersion: ""
  },
  baseWord: {
    init: false,
    isEdit: false,
    localeNo: "",
    selectedItemId: 1,
    items: JSON.parse(JSON.stringify(QuestionData.QUESTIONS)),
    lockVersion: ""
  },
  additions: {
    init: false,
    isEdit: false,
    localeNo: "",
    selectedItemId: 0,
    choices: JSON.parse(JSON.stringify(QuestionData.CHOICES)),
    items: {},
    defaultItems: {},
    lockVersion: ""
  },
  replaceModal: {
    open: false,
    key1: 0,
    key2: 0,
    key3: 0,
    key4: 0,
    key5: 0
  },
  previewModal: {
    open: false,
    localeNo: "",
    choices: JSON.parse(JSON.stringify(QuestionData.CHOICES)),
    items: [],
    selectedItemId: 0,
    additionMode: false
  },
  selectSurveyModal: {
    open: false,
    surveyList: [],
    errors: []
  },
  customer: new Customer(),
  locales: [],
  survey: new Survey(),
  surveys: [],
  customerId: "",
  attrUpdatedAt: "",
  errors: [],
  isMailSendToEmployee: false,
};

// Reducer
const createSurvey = (state = initialState, action) => {
  switch (action.type) {
    /* Common */
    case SET_CREATE_SURVEY_CUSTOMER_ID: {
      const { id } = action;
      const newState = JSON.parse(
        JSON.stringify({
          baseInfo: {
            init: false,
            canUseLocales: [],
            useLocales: [],
            localeNo: "",
            employees: 0,
            additionLimit: 0,
            items: {},
            termFrom: "",
            termTo: "",
            baseSurveyId: "",
            lockVersion: ""
          },
          selectAttr: {
            init: false,
            selectedAttrs: [],
            localeNo: "",
            answerMethods: {},
            items: [],
            lockVersion: ""
          },
          baseWord: {
            init: false,
            isEdit: false,
            localeNo: "",
            selectedItemId: 1,
            items: JSON.parse(JSON.stringify(QuestionData.QUESTIONS)),
            lockVersion: ""
          },
          additions: {
            init: false,
            isEdit: false,
            localeNo: "",
            selectedItemId: 0,
            choices: JSON.parse(JSON.stringify(QuestionData.CHOICES)),
            items: {},
            defaultItems: {},
            lockVersion: ""
          },
          replaceModal: {
            open: false,
            key1: 0,
            key2: 0,
            key3: 0,
            key4: 0,
            key5: 0
          },
          previewModal: {
            open: false,
            localeNo: "",
            choices: JSON.parse(JSON.stringify(QuestionData.CHOICES)),
            items: [],
            selectedItemId: 0,
            additionMode: false
          },
          selectSurveyModal: {
            open: false,
            surveyList: []
          },
          customer: new Customer(),
          locales: [],
          survey: new Survey(),
          surveys: [],
          customerId: "",
          attrUpdatedAt: "",
          errors: []
        })
      );

      return { ...newState, customerId: id };
    }
    case SET_CREATE_SURVEY_DETAIL: {
      const newState = state;
      const {
        surveys,
        locales,
        customer,
        survey,
        surveyLocales,
        canUseLocales,
        selectedAttrs,
        attrs,
        customerLocales,
        baseWordItems,
        additionsItems,
        attrUpdatedAt,
        isChecked,
        alertDays,
        isMailSendToEmployee
      } = action;

      // 過去の設定一覧
      const surveyList = surveys.map(sv => new Survey(sv));

      // 過去アンケート一覧
      newState.errors = [];
      newState.selectSurveyModal.surveyList = surveyList;

      // 基本情報
      newState.baseInfo.employees = customer.employees;
      newState.baseInfo.canUseLocales = [];
      newState.baseInfo.useLocales = [];

      // 属性選択
      newState.selectAttr.selectedAttrs = [];
      newState.selectAttr.items = attrs || JSON.parse(JSON.stringify(Attrs()));

      // 新規/既存
      if (survey.isNew()) {
        /* 新規 */
        // 基本情報
        newState.baseInfo.init = true;
        newState.baseInfo.additionLimit = 20;
        newState.baseInfo.termFrom = null;
        newState.baseInfo.termTo = null;
        // 初期値は全てのデフォルト属性にチェックを入れる
        const defaultAttrs = JSON.parse(JSON.stringify(Attrs()));
        _.each(newState.selectAttr.items, attr => {
          const selectedAttr = _.find(defaultAttrs, defaultAttr => {
            return defaultAttr.attrNo === attr.attrNo;
          });
          attr.isSelect = selectedAttr !== undefined;
        });

        // 言語別
        newState.baseInfo.canUseLocales = canUseLocales;
        locales.forEach(locale => {
          const localeKey = locale.locale.key;

          newState.baseInfo.useLocales.push(localeKey);
          newState.baseInfo.items[localeKey] = {
            surveyName: "従業員満足度調査NiserES",
            surveyExplain: "アンケートの説明（編集してください）",
            // 自由記入１の説明 のデフォルト値
            freeCommentDescription1:
              QuestionData.SENTENSE[localeKey].freeCommentTitle,
            freeCommentDescription2: ""
          };

          // 自由記入２のチェックのデフォルトはオフ
          newState.baseInfo.freeCommentCheck2 = false;

          newState.selectAttr.answerMethods[localeKey] =
            locale.answerDescription;

          // 追加設問の言語別配列を用意（基本設問はinitStateで設定済み）
          newState.additions.items[localeKey] = [];
        });
      } else {
        /* 既存 */
        newState.baseInfo.employees = survey.employees;
        newState.baseInfo.additionLimit = survey.additionLimit;
        newState.baseInfo.originTermFrom = survey.startDtFmt(DATE_FORMAT); // バリデーションチェック用の開始日時
        newState.baseInfo.termFrom = survey.startDtFmt(DATE_FORMAT);
        newState.baseInfo.termTo = survey.endDtFmt(DATE_FORMAT);
        newState.baseInfo.freeCommentCheck2 = survey.freeCommentCheck2;

        // 顧客使用可能言語(Rails側で編集済み)
        // 公開前: 顧客情報の使用可能言語のみ
        // 公開後: 顧客情報の使用可能言語＋アンケートの使用可能言語
        // ※ ただし、アンケートのみ保持する使用可能言語を外して更新した場合は再度選択することはできない
        newState.baseInfo.canUseLocales = canUseLocales;

        // アンケート基本情報
        surveyLocales.forEach(sl => {
          // アンケート使用言語
          // 公開前: 顧客言語＆アンケート言語
          // 公開後: アンケート言語のみ
          if (survey.isOpened()) {
            newState.baseInfo.useLocales.push(sl.locale.key);
          } else if (customerLocales.indexOf(sl.locale.key) > -1) {
            newState.baseInfo.useLocales.push(sl.locale.key);
          }
          newState.baseInfo.items[sl.locale.key] = {
            surveyName: sl.surveyName,
            surveyExplain: sl.surveyExplain,
            freeCommentDescription1: sl.freeCommentDescription1,
            freeCommentDescription2: sl.freeCommentDescription2
          };
          newState.selectAttr.answerMethods[sl.locale.key] =
            sl.answerDescription || "";
        });

        // 選択済み属性をチェック
        _.each(newState.selectAttr.items, attr => {
          const selectedAttr = _.find(selectedAttrs, id => {
            return parseInt(id, 10) === attr.id;
          });
          attr.isSelect = selectedAttr !== undefined;
        });
        // 基本文言設定
        newState.baseWord.isEdit = survey.editQuestionsFlg === 1;
        newState.baseWord.items = baseWordItems;
        newState.baseWord.selectedItemId = newState.baseInfo.useLocales[0]
          ? baseWordItems[newState.baseInfo.useLocales[0]][0].id
          : 0;
        // 追加設問
        newState.additions.selectedItemId = 0;
        if (
          newState.baseInfo.useLocales[0] &&
          additionsItems[newState.baseInfo.useLocales[0]].length
        ) {
          newState.additions.selectedItemId =
            additionsItems[newState.baseInfo.useLocales[0]][0].id;
        }
        newState.additions.isEdit = survey.editAdditionsFlg === 1;
        newState.additions.items = additionsItems;
      }
      // 初期選択
      const { localeNo, useLocales } = newState.baseInfo;
      const initLocaleNo = _.find(
        newState.baseInfo.canUseLocales,
        useLocale => useLocale.key === localeNo
      )
        ? localeNo
        : useLocales[0];
      newState.baseInfo.localeNo = initLocaleNo;
      newState.selectAttr.localeNo = initLocaleNo;
      newState.baseWord.localeNo = initLocaleNo;
      newState.additions.localeNo = initLocaleNo;
      newState.previewModal.localeNo = initLocaleNo;
      newState.alertDays = alertDays;
      newState.isChecked = isChecked;
      newState.isMailSendToEmployee = isMailSendToEmployee;
      return { ...newState, customer, locales, survey, attrUpdatedAt };
    }
    // 過去アンケートの適用
    case APPLY_CREATE_SURVEY_DETAIL: {
      const {
        survey,
        attrs,
        baseWordItems,
        additionsItems,
        selectedAttrs,
        surveyLocales
      } = action;
      const newState = state;
      // 過去アンケート一覧
      newState.errors = [];

      // 基本情報
      newState.baseInfo.employees = survey.employees;
      newState.baseInfo.additionLimit = survey.additionLimit;
      newState.baseInfo.termFrom = survey.startDtFmt(DATE_FORMAT);
      newState.baseInfo.termTo = survey.endDtFmt(DATE_FORMAT);
      newState.baseInfo.useLocales = [];
      newState.baseInfo.baseSurveyId = survey.id;
      newState.baseInfo.freeCommentCheck2 = survey.freeCommentCheck2;

      // 属性選択
      newState.selectAttr.selectedAttrs = [];
      newState.selectAttr.items = attrs;

      surveyLocales.forEach(sl => {
        if (
          _.find(
            newState.baseInfo.canUseLocales,
            useLocale => useLocale.key === sl.locale.key
          )
        ) {
          newState.baseInfo.useLocales.push(sl.locale.key);
          newState.baseInfo.items[sl.locale.key] = {
            surveyName: sl.surveyName,
            surveyExplain: sl.surveyExplain,
            freeCommentDescription1: sl.freeCommentDescription1,
            freeCommentDescription2: sl.freeCommentDescription2
          };
          newState.selectAttr.answerMethods[sl.locale.key] =
            sl.answerDescription || "";
        }
      });

      // 選択済み属性をチェック
      _.each(newState.selectAttr.items, attr => {
        const selectedAttr = _.find(selectedAttrs, id => {
          return parseInt(id, 10) === attr.id;
        });
        attr.isSelect = selectedAttr !== undefined;
      });

      const initLocaleNo = newState.baseInfo.useLocales[0];
      // 基本設問文言
      newState.baseWord.init = true;
      newState.baseWord.isEdit = survey.editQuestionsFlg === 1;
      newState.baseWord.items = baseWordItems;
      newState.baseWord.selectedItemId =
        initLocaleNo && baseWordItems[initLocaleNo].length
          ? baseWordItems[initLocaleNo][0].id
          : 0;

      // 追加設問
      newState.additions.init = true;
      newState.additions.isEdit = survey.editAdditionsFlg === 1;
      newState.additions.items = additionsItems;
      newState.additions.selectedItemId =
        initLocaleNo && additionsItems[initLocaleNo].length
          ? additionsItems[initLocaleNo][0].id
          : 0;

      // 初期選択
      newState.baseInfo.localeNo = initLocaleNo;
      newState.selectAttr.localeNo = initLocaleNo;
      newState.baseWord.localeNo = initLocaleNo;
      newState.additions.localeNo = initLocaleNo;
      newState.previewModal.localeNo = initLocaleNo;
      newState.isMailSendToEmployee = survey.isMailSendToEmployee;

      return { ...newState };
    }
    case SET_ALERT_CONFIG:
      return {
        ...state,
        alertDays: action.alertDays,
        isChecked: action.isChecked
      };
    case SET_MAIL_SEND_TO_EMPLOYEE:
      return {
        ...state,
        isMailSendToEmployee: action.isMailSendToEmployee,
      };
    /* BaseInfo */
    case SET_BASE_INFO_LOCALE: {
      const newState = state;
      const { localeNo } = action;
      newState.baseInfo.localeNo = localeNo;
      return { ...newState };
    }
    case CHANGE_BASE_INFO_USE_LOCALE: {
      const { localeNo, check } = action;
      const newState = state;
      let useLocales = [];
      const { items } = state.baseInfo;

      if (check) {
        const asUseLocales = state.baseInfo.useLocales;
        asUseLocales.push(localeNo);
        state.locales.forEach(locale => {
          if (asUseLocales.indexOf(locale.locale.key) > -1) {
            useLocales.push(locale.locale.key);
          }
        });

        items[localeNo] = {
          surveyName: "従業員満足度調査NiserES",
          surveyExplain: "アンケートの説明（編集してください）",
          // 自由記入１の説明 のデフォルト値
          freeCommentDescription1:
            QuestionData.SENTENSE[localeNo].freeCommentTitle,
          freeCommentDescription2: ""
        };

        // チェックは言語間で合わせる
        newState.baseInfo.freeCommentCheck2 = state.baseInfo.freeCommentCheck2;

        // 基本文言
        newState.baseWord.items[localeNo] = JSON.parse(
          JSON.stringify(QuestionData.QUESTIONS[localeNo])
        );
        newState.baseWord.selectedItemId =
          newState.baseWord.items[localeNo][0].id;

        // 追加設問
        // 対象言語の追加設問配列が作成の場合は作成
        if (!newState.additions.items[localeNo]) {
          newState.additions.items[localeNo] = [];
        }
        if (Object.keys(newState.additions.items).length > 0) {
          // 追加設問数が多い言語をベースとする
          let baseAddItems = [];
          useLocales.forEach(locale => {
            const target = newState.additions.items[locale];
            if (baseAddItems.length < target.length) {
              baseAddItems = target;
            }
          });
          // ベースの設問数分の空設問を作成
          baseAddItems.forEach(item => {
            const newItem = () => ({
              id: item.id,
              title: "",
              content: "",
              choices: JSON.parse(JSON.stringify(item.choices))
            });
            newState.additions.items[localeNo].push(newItem(localeNo));
          });
        } else if (!newState.additions.items[localeNo]) {
          newState.additions.items[localeNo] = [];
        }
      } else {
        useLocales = _.without(state.baseInfo.useLocales, localeNo);
        // 基本情報の言語削除
        delete items[localeNo];
        // 基本文言設定
        delete newState.baseWord.items[localeNo];
        // 追加設問
        delete newState.additions.items[localeNo];

        const initLocaleNo = useLocales[0];
        newState.baseInfo.localeNo = initLocaleNo;
        newState.selectAttr.localeNo = initLocaleNo;
        newState.baseWord.localeNo = initLocaleNo;
        newState.additions.localeNo = initLocaleNo;
        newState.previewModal.localeNo = initLocaleNo;
      }
      useLocales = _.uniq(useLocales);
      // すべての言語が未選択となった場合は情報をクリア
      if (useLocales.indexOf(state.baseInfo.localeNo) === -1) {
        const initLocaleNo = _.first(useLocales);
        newState.baseInfo.localeNo = initLocaleNo;
        newState.selectAttr.localeNo = initLocaleNo;
        newState.baseWord.localeNo = initLocaleNo;
        newState.additions.localeNo = initLocaleNo;
        newState.previewModal.localeNo = initLocaleNo;
        // 追加設問のフォーカス位置をクリア
        newState.additions.selectedItemId = 0;
      }
      newState.baseInfo.useLocales = useLocales;
      newState.baseInfo.items = items;
      return { ...newState };
    }
    case CHANGE_BASE_INFO_ITEM: {
      const { key, value, locale } = action;

      const newState = !locale
        ? update(state, {
            baseInfo: {
              $merge: { [key]: value }
            }
          })
        : update(state, {
            baseInfo: {
              items: {
                [state.baseInfo.localeNo]: { $merge: { [key]: value } }
              }
            }
          });
      if (parseInt(newState.baseInfo.additionLimit, 10) === 0) {
        newState.additions.isEdit = false;
      }
      return { ...newState };
    }
    case CHANGE_BASE_INFO_TERM: {
      const { key, value } = action;
      // DatePickerの値を定数フォーマットへ変換
      const formattedDate = moment(value, "YYYYMMDDHHmm").format(DATE_FORMAT);
      const newState = update(state, {
        baseInfo: {
          $merge: { [key]: formattedDate }
        }
      });
      return { ...newState };
    }

    // 「自由記入２の説明」チェックボックスの変更
    case CHANGE_FREE_COMMENT_CHECKBOX_2: {
      const checkBoxFlg = action.flg;

      // チェックを外したら、自由記入２の説明のテキストフィールドは空欄にする。
      // 全ての言語に適用するので、useLocalesでイテレートする
      const newItems = {};
      _.each(state.baseInfo.useLocales, localeKey => {
        const item = state.baseInfo.items[localeKey];
        const newItem = update(item, { freeCommentDescription2: { $set: "" } });
        newItems[localeKey] = newItem;
      });

      // 「自由記入２の説明」のチェックボックスのフラグと、
      // 全ての言語の「自由記入２の説明」を空欄にしたアイテムをセットする
      const newState = update(state, {
        baseInfo: {
          freeCommentCheck2: { $set: checkBoxFlg },
          items: { $set: newItems }
        }
      });

      return newState;
    }

    case UPDATE_BASE_INFO: {
      const newState = state;
      return { ...newState };
    }

    /* SelectAttr */
    case SET_SELECT_ATTR_LOCALE: {
      const newState = state;
      const { localeNo } = action;
      newState.selectAttr.localeNo = localeNo;
      return { ...newState };
    }
    case RELOAD_SELECT_ATTR: {
      const newState = state;
      const { res } = action;

      // 属性選択
      newState.selectAttr.selectedAttrs = [];
      newState.selectAttr.items =
        res.attrs || JSON.parse(JSON.stringify(Attrs()));

      res.locales.forEach(l => {
        newState.selectAttr.answerMethods[l.locale.key] =
          l.answerDescription || "";
      });

      // 選択済み属性をチェック
      _.each(newState.selectAttr.items, attr => {
        const selectedAttr = _.find(res.selectedAttrs, id => {
          return parseInt(id, 10) === attr.id;
        });
        attr.isSelect = selectedAttr !== undefined;
      });

      const dept = _.find(newState.selectAttr.items, attr => {
        return attr.deptFlg;
      });
      if (dept) dept.isSelect = true;

      // 初期選択
      const { useLocales } = newState.baseInfo;
      const localeNo = useLocales[0];
      newState.selectAttr.localeNo = localeNo;

      return { ...newState, attrUpdatedAt: res.attrUpdatedAt };
    }
    case CHANGE_SELECT_ATTR_USE_ATTRS: {
      const { index, check } = action;
      const newState = state;
      newState.selectAttr.items[index].isSelect = check;
      return { ...newState };
    }
    case CHANGE_SELECT_ATTR_ITEM: {
      const { key, value } = action;

      const newState = update(state, {
        selectAttr: {
          [key]: {
            [state.selectAttr.localeNo]: {
              $set: value
            }
          }
        }
      });

      return { ...newState };
    }
    case UPDATE_SELECT_ATTR: {
      const newState = state;
      return { ...newState };
    }

    /* BaseWord */
    case INIT_BASE_WORD: {
      const newState = state;
      newState.baseWord.init = true;
      newState.baseInfo.useLocales.forEach(useLocale => {
        newState.baseWord.items[useLocale] = JSON.parse(
          JSON.stringify(QuestionData.QUESTIONS[useLocale])
        );
      });
      return { ...newState };
    }
    case SET_BASE_WORD_INFO: {
      const newState = state;
      const { res } = action;
      newState.errors = [];
      newState.survey = new Survey(res.survey);
      newState.baseInfo.useLocales = [];

      const customerLocales = res.locales.map(locale => locale.locale.key);

      res.surveyLocales.forEach(sl => {
        if (customerLocales.indexOf(sl.locale.key) > -1) {
          newState.baseInfo.useLocales.push(sl.locale.key);
        }
      });
      newState.baseWord.isEdit = res.survey.editQuestionsFlg === 1;
      newState.baseWord.items = res.items;
      const localeNo = newState.baseInfo.useLocales[0];

      newState.baseWord.selectedItemId = res.items[localeNo][0].id;
      newState.baseWord.localeNo = localeNo;
      newState.previewModal.localeNo = localeNo;

      return { ...newState };
    }
    case SET_BASE_WORD_LOCALE: {
      const newState = state;
      const { localeNo } = action;
      newState.baseWord.localeNo = localeNo;
      return { ...newState };
    }
    case SET_BASE_WORD_EDIT: {
      const newState = state;
      const { check } = action;
      newState.baseWord.isEdit = check;
      return { ...newState };
    }
    case SET_BASE_WORD_SELECT_ID: {
      const newState = state;
      const { id } = action;
      newState.baseWord.selectedItemId = id;
      return { ...newState };
    }
    case UPDATE_BASE_WORD_ITEMS: {
      const { item, index, atIndex } = action;
      const newState = update(state, {
        baseWord: {
          items: {
            $splice: [[index, 1], [atIndex, 0, item]]
          }
        }
      });
      return { ...newState };
    }
    case CHANGE_BASE_WORD_ITEM: {
      const { key, value } = action;
      const { items, selectedItemId, localeNo } = state.baseWord;
      const item = items[localeNo].filter(
        i => i.id === parseInt(selectedItemId, 10)
      )[0];
      const index = items[localeNo].indexOf(item);
      const newState = update(state, {
        baseWord: {
          items: {
            [localeNo]: {
              [index]: {
                $merge: { [key]: value }
              }
            }
          }
        }
      });
      return { ...newState };
    }
    case CHANGE_BASE_WORD_SELECTION: {
      const { moveNo } = action;
      const newState = update(state, {
        baseWord: {
          $merge: {
            selectedItemId: parseInt(state.baseWord.selectedItemId, 10) + moveNo
          }
        }
      });
      return { ...newState };
    }
    case OPEN_BASE_WORD_REPLACE_MODAL: {
      const replaceModal = {
        open: true
      };
      return { ...state, replaceModal };
    }
    case CLOSE_BASE_WORD_REPLACE_MODAL: {
      const replaceModal = {
        open: false
      };
      return { ...state, replaceModal };
    }
    case DISCARD_BASE_WORD: {
      const localeNo = state.baseInfo.useLocales[0];
      if (action.res) {
        const newState = state;
        const { res } = action;
        newState.baseWord.isEdit = res.survey.editQuestionsFlg === 1;
        newState.baseWord.items = res.items;
        state.baseInfo.useLocales.forEach(locale => {
          if (!newState.baseWord.items[locale]) {
            newState.baseWord.items[locale] = JSON.parse(
              JSON.stringify(QuestionData.QUESTIONS[locale])
            );
          }
        });
        newState.baseWord.selectedItemId = !res.items[localeNo].length
          ? 0
          : res.items[localeNo][0].id;

        newState.baseWord.localeNo = localeNo;
        newState.previewModal.localeNo = localeNo;

        return { ...newState };
      }
      const baseWord = {
        isEdit: false,
        localeNo: state.baseInfo.useLocales[0],
        selectedItemId: 1,
        items: JSON.parse(JSON.stringify(QuestionData.QUESTIONS))
      };
      const replaceModal = {
        open: false,
        key1: 0,
        key2: 0,
        key3: 0,
        key4: 0,
        key5: 0
      };

      return { ...state, baseWord, replaceModal };
    }
    case REPLACE_ALL_BASE_WORD: {
      const newState = state;
      const { selectKeys } = action;
      newState.baseWord.items.ja.forEach(item => {
        if (selectKeys.key1 !== 1) {
          item.content = item.content.replace(
            /当社/g,
            Keywords.KEY1.filter(k => k.id === selectKeys.key1)[0].word
          );
        }
        if (selectKeys.key2 !== 1) {
          item.content = item.content.replace(
            /社員/g,
            Keywords.KEY2.filter(k => k.id === selectKeys.key2)[0].word
          );
        }
        if (selectKeys.key3 !== 1) {
          item.content = item.content.replace(
            /経営トップ層/g,
            Keywords.KEY3.filter(k => k.id === selectKeys.key3)[0].word
          );
        }
        if (selectKeys.key4 !== 1) {
          item.content = item.content.replace(
            /上司/g,
            Keywords.KEY4.filter(k => k.id === selectKeys.key4)[0].word
          );
        }
        if (selectKeys.key5 !== 1) {
          item.content = item.content.replace(
            /部署/g,
            Keywords.KEY5.filter(k => k.id === selectKeys.key5)[0].word
          );
        }
      });
      return { ...newState };
    }
    case UPDATE_BASE_WORD: {
      const newState = state;
      return { ...newState };
    }

    /* Additions */
    case INIT_ADDITIONS: {
      const newState = state;
      newState.additions.init = true;
      newState.baseInfo.useLocales.forEach(useLocale => {
        newState.additions.items[useLocale] = [];
      });
      return { ...newState };
    }
    case SET_ADDITIONS_INFO: {
      const newState = state;
      const { res } = action;
      newState.errors = [];
      newState.survey = new Survey(res.survey);
      newState.baseInfo.useLocales = [];

      newState.baseInfo.additionLimit = res.survey.additionLimit;
      const customerLocales = res.locales.map(locale => locale.locale.key);
      res.surveyLocales.forEach(sl => {
        if (customerLocales.indexOf(sl.locale.key) > -1) {
          newState.baseInfo.useLocales.push(sl.locale.key);
        }
      });
      newState.additions.isEdit = res.survey.editAdditionsFlg === 1;
      newState.additions.items = res.items;
      newState.additions.selectedItemId = !res.items[
        newState.baseInfo.useLocales[0]
      ].length
        ? 0
        : res.items[newState.baseInfo.useLocales[0]][0].id;

      const localeNo = newState.baseInfo.useLocales[0];
      newState.additions.localeNo = localeNo;
      newState.previewModal.localeNo = localeNo;

      return { ...newState };
    }
    case SET_ADDITIONS_LOCALE: {
      const newState = state;
      const { localeNo } = action;
      newState.additions.localeNo = localeNo;
      return { ...newState };
    }
    case SET_ADDITIONS_EDIT: {
      const newState = state;
      const { check } = action;
      newState.additions.isEdit = check;
      return { ...newState };
    }
    case SET_ADDITIONS_SELECT_ID: {
      const newState = state;
      const { id } = action;
      newState.additions.selectedItemId = id;
      return { ...newState };
    }
    case ADD_ADDITIONS_NEW_ITEM: {
      const { items, localeNo } = state.additions;
      const maxItem = _.max(items[localeNo], item => {
        return item.id;
      });
      const newId = maxItem === -Infinity ? 64 : maxItem.id + 1;
      const newItem = locale => ({
        id: newId,
        title: "",
        content: "",
        choices: JSON.parse(
          JSON.stringify(QuestionData.CHOICES[locale].answers)
        )
      });
      state.baseInfo.useLocales.forEach(locale => {
        if (!state.additions.items[locale]) {
          state.additions.items[locale] = [];
        }
        state.additions.items[locale].push(newItem(locale));
      });
      state.additions.selectedItemId = newId;
      return { ...state };
    }
    case REMOVE_ADDITIONS_ITEM: {
      const newState = state;
      const { index } = action;
      const { items, localeNo } = state.additions;
      let { selectedItemId } = state.additions;
      const removeItem = _.find(items[localeNo], item => {
        return item.id === parseInt(index, 10);
      });
      const itemIndex = _.indexOf(items[localeNo], removeItem);

      // 追加設問を削除
      state.baseInfo.useLocales.forEach(locale => {
        newState.additions.items[locale].splice(itemIndex, 1);
      });
      // 削除後にフォーカスする設問を設定
      const selectIndex =
        itemIndex === newState.additions.items[localeNo].length
          ? itemIndex - 1
          : itemIndex;
      selectedItemId =
        newState.additions.items[localeNo].length > 0
          ? newState.additions.items[localeNo][selectIndex].id
          : 0;
      newState.additions.selectedItemId = selectedItemId;

      return { ...newState };
    }
    case CHANGE_ADDITIONS_ITEM: {
      const { value } = action;
      const { items, selectedItemId, localeNo } = state.additions;

      const item = _.find(items[localeNo], i => {
        return i.id === parseInt(selectedItemId, 10);
      });
      const index = items[localeNo].indexOf(item);
      const newState = update(state, {
        additions: {
          items: {
            [localeNo]: {
              [index]: {
                $merge: { title: value.substr(0, 10), content: value }
              }
            }
          }
        }
      });
      return { ...newState };
    }
    case UPDATE_ADDITIONS_ITEMS: {
      const { index, atIndex } = action;
      let newState = state;
      state.baseInfo.useLocales.forEach(locale => {
        const item = newState.additions.items[locale][index];
        newState = update(newState, {
          additions: {
            items: {
              [locale]: {
                $splice: [[index, 1], [atIndex, 0, item]]
              }
            }
          }
        });
      });
      return { ...newState };
    }
    case ADD_ADDITIONS_NEW_ANSWER: {
      const { items, selectedItemId, localeNo } = state.additions;
      const targetItem = _.find(items[localeNo], i => {
        return i.id === parseInt(selectedItemId, 10);
      });
      const itemIndex = items[localeNo].indexOf(targetItem);
      const maxAnswer = _.max(targetItem.choices, choice => {
        return choice.id;
      });
      const newId = maxAnswer === -Infinity ? 1 : maxAnswer.id + 1;
      const choice = {
        id: newId,
        name: "",
        order: newId
      };
      state.baseInfo.useLocales.forEach(locale => {
        items[locale][itemIndex].choices.push(choice);
      });
      return { ...state };
    }
    case REMOVE_ADDITIONS_ANSWER: {
      const { index } = action;
      const { items, selectedItemId, localeNo } = state.additions;
      const targetItem = _.find(items[localeNo], i => {
        return i.id === parseInt(selectedItemId, 10);
      });
      const itemIndex = items[localeNo].indexOf(targetItem);
      state.baseInfo.useLocales.forEach(locale => {
        items[locale][itemIndex].choices.splice(index, 1);
      });

      return { ...state };
    }
    case CHANGE_ADDITIONS_ANSWER: {
      const { index, name } = action;
      const { items, selectedItemId, localeNo } = state.additions;
      const item = _.find(items[localeNo], i => {
        return i.id === parseInt(selectedItemId, 10);
      });
      const itemIndex = items[localeNo].indexOf(item);
      const newState = update(state, {
        additions: {
          items: {
            [localeNo]: {
              [itemIndex]: {
                choices: {
                  [index]: {
                    $merge: { name }
                  }
                }
              }
            }
          }
        }
      });
      return { ...newState };
    }
    case SET_ADDITIONS_PT_REVERSE: {
      const { items, selectedItemId, localeNo } = state.additions;
      const item = items[localeNo].filter(
        i => i.id === parseInt(selectedItemId, 10)
      )[0];
      const index = items[localeNo].indexOf(item);
      const reverse = !items[localeNo][index].reverse;
      state.baseInfo.useLocales.forEach(locale => {
        state.additions.items[locale][index].reverse = reverse;
      });
      item.choices.reverse()

      return { ...state };
    }
    case DISCARD_ADDITIONS: {
      const localeNo = state.baseInfo.useLocales[0];
      if (action.res) {
        const newState = state;
        const { res } = action;
        newState.additions.isEdit = res.survey.editAdditionsFlg === 1;
        newState.additions.items = res.items;
        state.baseInfo.useLocales.forEach(locale => {
          // 過去の設定に追加設問が存在し、アンケート言語に一致するデータが無い場合
          if (!newState.additions.items[locale]) {
            if (Object.keys(res.items).length) {
              // 過去の設問数分、アンケート言語の設問を用意
              res.items[Object.keys(res.items)[0]].forEach(item => {
                const newItem = {
                  id: item.id,
                  title: "",
                  content: "",
                  choices: JSON.parse(JSON.stringify(item.choices))
                };
                if (!newState.additions.items[locale]) {
                  newState.additions.items[locale] = [];
                }
                newState.additions.items[locale].push(newItem);
              });
            } else {
              newState.additions.items[locale] = [];
            }
          }
        });

        newState.additions.selectedItemId = !res.items[localeNo].length
          ? 0
          : res.items[localeNo][0].id;

        newState.additions.localeNo = localeNo;
        newState.previewModal.localeNo = localeNo;
        return { ...newState };
      }
      const items = {};
      state.baseInfo.useLocales.forEach(locale => {
        items[locale] = [];
      });

      const additions = {
        isEdit: false,
        localeNo,
        selectedItemId: 0,
        items
      };

      return { ...state, additions };
    }
    case UPDATE_ADDITIONS: {
      const newState = state;
      return { ...newState };
    }

    case OPEN_PREVIEW_MODAL: {
      const { localeNo, selectedItemId, items, additionMode } = action;

      const choices = action.choices
        ? action.choices
        : JSON.parse(JSON.stringify(QuestionData.CHOICES));
      const newState = update(state, {
        previewModal: {
          $merge: {
            open: true,
            selectedItemId,
            items,
            choices,
            localeNo,
            additionMode
          }
        }
      });
      return { ...newState };
    }
    case CLOSE_PREVIEW_MODAL: {
      const newState = update(state, {
        previewModal: {
          $merge: { open: false }
        }
      });
      return { ...newState };
    }
    case SET_CREATE_SURVEY_ERRORS: {
      const { errors } = action;
      return { ...state, errors };
    }
    /* SElectSurveyModal */
    case SET_SELECT_SURVEY_ERRORS: {
      const { errors } = action;
      const newState = update(state, {
        selectSurveyModal: {
          $merge: { errors }
        }
      });
      return { ...newState };
    }
    /* PreviewModal */
    case SET_PREVIEW_LOCALE: {
      const { localeNo } = action;
      const newState = update(state, {
        previewModal: {
          $merge: { localeNo }
        }
      });
      return { ...newState };
    }
    case CHANGE_PREVIEW_ITEM: {
      const { moveNo } = action;
      const { selectedItemId, localeNo, items } = state.previewModal;
      const currentItem = items[localeNo].filter(
        c => c.id - selectedItemId === 0
      )[0];
      const index = items[localeNo].indexOf(currentItem);
      const nextItem = items[localeNo][index + moveNo];
      const hasAnswers = _.pluck(nextItem, "answers")[0];
      const choices = hasAnswers
        ? nextItem.answers
        : state.previewModal.choices;
      const newState = update(state, {
        previewModal: {
          $merge: {
            selectedItemId: nextItem.id,
            choices
          }
        }
      });
      return { ...newState };
    }
    case OPEN_SELECT_SURVEY_MODAL: {
      const newState = update(state, {
        selectSurveyModal: {
          $merge: { open: true }
        }
      });
      return { ...newState };
    }
    case CLOSE_SELECT_SURVEY_MODAL: {
      const newState = update(state, {
        selectSurveyModal: {
          $merge: { open: false }
        }
      });
      return { ...newState };
    }
    case SET_ATTR_UPDATE_AT: {
      const { attrUpdatedAt } = action;
      return { ...state, attrUpdatedAt };
    }
    default:
      return state;
  }
};

export default createSurvey;



// WEBPACK FOOTER //
// ./src/redux/modules/createSurvey.js